import { Col, Row } from "react-grid-system";
import { PropTypes } from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { StyledField } from "../../../styles/StyledField";
import { StyledModalFooterActions } from "../../../styles/StyledAddUpperDecision";
import { Button } from "../../Button";
import AddIcon from "../../../assets/img/icons/add.svg";
import { AddMinuteContainer } from "../../../styles/StyledMeeting";

export default function AddMinute({ id, meetingPoints, closeModal, handleUpdate }) {
	const [title, setTitle] = useState();
	const [details, setDetails] = useState();
	const [minutes, setMinutes] = useState();

	useEffect(() => {
		setTitle(meetingPoints[id]?.title);
		setDetails(meetingPoints[id]?.details);
		setMinutes(meetingPoints[id]?.minutes);
	}, [id, meetingPoints]);

	return (
		<AddMinuteContainer>
			<Row>
				<Col sm={12}>
					<label>Agenda item topic</label>
					<h5>{title}</h5>
				</Col>
			</Row>
			<Row>
				<Col sm={12}>
					<label>Agenda item description</label>
					<p>{details}</p>
				</Col>
			</Row>
			<Row>
				<Col sm={12}>
					<StyledField edit={true} small>
						<label>Add minute</label>
						<textarea value={minutes} onChange={(e) => setMinutes(e.target.value)} />
					</StyledField>
				</Col>
			</Row>
			<StyledModalFooterActions>
				<Button onClick={() => closeModal()} bg={false} small={true}>
					Cancel
				</Button>
				<Button icon={AddIcon} onClick={() => handleUpdate(minutes)}>
					Confirm
				</Button>
			</StyledModalFooterActions>
		</AddMinuteContainer>
	);
}

AddMinute.propTypes = {
	id: PropTypes.string,
	meetingPoints: PropTypes.any,
	closeModal: PropTypes.func,
	handleUpdate: PropTypes.func,
};
